import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {PermissionService} from '@app/Services/permission.service';
import {ToastMessageType, ToastService} from '@app/Common/toast';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuard  {

  public constructor(private permissionService: PermissionService, private toastService: ToastService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const permissionsRequired: string[] = next.data.permissionsRequired;
    const hasPassed = permissionsRequired.every(permission => this.permissionService.hasPermission(permission));
    if(!hasPassed){
      this.toastService.sendMessage('No Access', 'You do not have permission for this feature', ToastMessageType.warning);
    }
    return hasPassed;
  }
}
